import {ActivityFilterDateRangeTypes} from '@shared/models/activity-tracker-header.model';
import {DateRangeEnumType} from './activity.model';
/**
 * Created by jahidul.hasan on 2/2/2021.
 */
export class ActivityDateRangeTypeScope {
  static getDateRangeTypeGraphQl (val) {
    switch (val) {
      case ActivityFilterDateRangeTypes.Custom:
        return 'CUSTOM';
      case ActivityFilterDateRangeTypes.Last30Days:
        return 'LAST_30_DAYS';
      case ActivityFilterDateRangeTypes.Last90Days:
        return 'LAST_90_DAYS';
      case ActivityFilterDateRangeTypes.Last7Days:
        return 'LAST_7_DAYS';
      case ActivityFilterDateRangeTypes.Quarter1:
        return 'QUARTER_1';
      case ActivityFilterDateRangeTypes.Quarter2:
        return 'QUARTER_2';
      case ActivityFilterDateRangeTypes.Quarter3:
        return 'QUARTER_3';
      case ActivityFilterDateRangeTypes.Quarter4:
        return 'QUARTER_4';
      case ActivityFilterDateRangeTypes.Today:
        return 'TODAY';
      default:
        return val;
    }
  }

  static getDateRangeEnum(dateRangeType: string) {
    switch (dateRangeType) {
      case ActivityFilterDateRangeTypes.Custom:
        return DateRangeEnumType.Custom;
      case ActivityFilterDateRangeTypes.Last30Days:
        return DateRangeEnumType.Last30Days;
      case ActivityFilterDateRangeTypes.Last90Days:
        return DateRangeEnumType.Last90Days;
      case ActivityFilterDateRangeTypes.Last7Days:
        return DateRangeEnumType.Last7Days;
      case ActivityFilterDateRangeTypes.Quarter1:
        return DateRangeEnumType.Quarter1;
      case ActivityFilterDateRangeTypes.Quarter2:
        return DateRangeEnumType.Quarter2;
      case ActivityFilterDateRangeTypes.Quarter3:
        return DateRangeEnumType.Quarter3;
      case ActivityFilterDateRangeTypes.Quarter4:
        return DateRangeEnumType.Quarter4;
      case ActivityFilterDateRangeTypes.Today:
        return DateRangeEnumType.Today;
      default:
        return -1;
    }
  }

  static getDateRangeTypeId(dateRangeType: number) {
    switch (dateRangeType) {
      case DateRangeEnumType.Custom:
        return ActivityFilterDateRangeTypes.Custom;
      case DateRangeEnumType.Last30Days:
        return ActivityFilterDateRangeTypes.Last30Days;
      case DateRangeEnumType.Last90Days:
        return ActivityFilterDateRangeTypes.Last90Days;
      case DateRangeEnumType.Last7Days:
        return ActivityFilterDateRangeTypes.Last7Days;
      case DateRangeEnumType.Quarter1:
        return ActivityFilterDateRangeTypes.Quarter1;
      case DateRangeEnumType.Quarter2:
        return ActivityFilterDateRangeTypes.Quarter2;
      case DateRangeEnumType.Quarter3:
        return ActivityFilterDateRangeTypes.Quarter3;
      case DateRangeEnumType.Quarter4:
        return ActivityFilterDateRangeTypes.Quarter4;
      case DateRangeEnumType.Today:
        return ActivityFilterDateRangeTypes.Today;
      default:
        return -1;
    }
  }
}
